export default {
    pagination:'pagination'
};
